import React from "react";

const WufooIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_360)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.67053 10.2576C1.80667 14.7408 5.48381 18.3333 9.99996 18.3333C14.6023 18.3333 18.3333 14.6023 18.3333 10C18.3333 5.39766 14.6023 1.66667 9.99996 1.66667C5.48381 1.66667 1.80667 5.25924 1.67053 9.74238V10.2576Z",
  fill: "#E66760"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.24857 15.1397L3.25195 7.21393L5.97442 6.35072L8.09096 11.0901L8.38145 6.00215L10.747 5.54557L12.93 10.202L13.1261 5.08672L15.5611 4.60768L14.8639 13.6632L12.3157 14.1695L10.1162 9.6127L9.80912 14.6674L7.24857 15.1397Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_360"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.6667,
  height: 16.6667,
  fill: "white",
  transform: "translate(1.66663 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(WufooIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;